import React from 'react';
import PropTypes from 'prop-types';
import { formatBlogEntryTimestamp } from '../../../../modules/datetime';
import { titleCase } from '../../../../src/shared/format';
import MediaGalleryImage from '../../../../modules/react/containers/MediaGalleryImage';
import style from './BlogEntry.scss';

const propTypes = {
  post: PropTypes.shape({
    author: PropTypes.string,
    category: PropTypes.object,
    id: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    snippet: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

const BlogEntry = ({
  post: {
    author, category, slug, snippet, date, title, mediumId,
  },
}) => (
  <div className={style.post}>
    <h2 className={`${style.name} color-primary-foreground`}>
      <a href={`/blog/${slug}`}>
        {title}
      </a>
    </h2>
    {category && (
      <p className={`bold ${style.categoryLink}`}>
        <a href={`/blog/category/${category.slug}`}>
          {titleCase(category.name)}
        </a>
      </p>
    )}
    <br />
    {mediumId && <MediaGalleryImage mediumId={mediumId} setMaxWidth className={style.image} />}
    <p className={style.truncatedText}>
      <a href={`/blog/${slug}`}>
        {snippet}
      </a>
    </p>
    <br />
    <p>
      {author || '—'}
      <br />
      {formatBlogEntryTimestamp(date)}
    </p>
  </div>
);

BlogEntry.propTypes = propTypes;

export default BlogEntry;
